var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-agency"},[_c('div',{staticClass:"page-header"},[_c('h1',[_vm._v("Onboard Agency")]),_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_c('i',{staticClass:"mdi mdi-home-outline"})]),_c('el-breadcrumb-item',[_vm._v("Agency")]),_c('el-breadcrumb-item',[_vm._v("Onboard")])],1)],1),_c('work-in-progress')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acbde028","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/agency/NewAgency.vue
// module id = null
// module chunks = 